import { Debounce } from '../../../../assets/js/common'
export default {
  name: 'pastCommodityList',
  data() {
    return {
      crmId: '',
      pageParams: {
        pageNum: 1,
        pageSize: 6,
        error: false,
        loading: false,
        bottomText: '已经到底啦～',
        finished: false,
      },
      hasGetData: false, // 是否获取过数据
      evaluationList: [], // 数据列表
    }
  },
  mounted() {
    //请求接口，获取问题答案和解析
    // 每日辟谣查询历史列表
    //接口请求历史查询
    this.crmId = JSON.parse(localStorage.getItem('userInfo')).crm_id
    this.getEvaluationList()
  },
  methods: {
    // 获取测评列表
    getEvaluationList() {
      this.$http.post(
        '/trial/previous/getComment',
        {},
        {
          crmId: this.crmId,
          pageNum: this.pageParams.pageNum,
          pageSize: this.pageParams.pageSize,
          goodsId: this.$route.params.goodsId,
        },
        (res) => {
          if (res.code === 200) {
            this.hasGetData = true
            const { data, total } = res.data
            this.evaluationList = this.evaluationList.concat([...data])
            console.log(res.data)
            // debugger
            this.$nextTick(() => {
              if (this.evaluationList.length >= total && data) {
                this.pageParams.finished = true
                this.pageParams.bottomText = '已经到底啦～'
              } else {
                this.pageParams.pageNum += 1
                this.pageParams.loading = false
              }
            })
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
              forbidClick: true,
              context: this,
            })
            this.loginFlag = true
          }
        },
        (err) => {
          this.hasGetData = true
          this.pageParams.loading = false
          this.pageParams.error = true
          console.log(err)
        },
        'lucky'
      )
    },
    goDetail: Debounce(function (id) {
      // 跳转测评详情页
      this.$router.push({ path: '/evaluationDetail/' + id })
    }),
    likeHandle: Debounce(function (item, index) {
      this.$http.post(
        '/trial/evaluation/like',
        {},
        {
          crmId: this.crmId,
          id: item.id,
          type: item.needLike ? 1 : 0,
        },
        (res) => {
          if (res.code === 200) {
            console.log(index, this.evaluationList[index])
            if (
              this.evaluationList[index].likeNum == 0 &&
              this.evaluationList[index].needLike == false
            ) {
              this.evaluationList[index].likeNum = 1
              this.evaluationList[index].needLike = !item.needLike
            } else {
              this.evaluationList[index].needLike = !item.needLike
              ;(item.needLike && this.evaluationList[index].likeNum++) ||
                this.evaluationList[index].likeNum--
            }

            // ;(item.needLike && this.evaluationList[index].likeNum++) ||
            //   this.evaluationList[index].likeNum--
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
              forbidClick: true,
              context: this,
            })
            this.loginFlag = true
          }
        },
        (err) => {
          console.log(err, 'error')
        },
        'lucky'
      )
    }),
    handleCommodityClick() {
      console.log('点击跳转详情页')
    },
  },
}
